import { useAppSelector, useAppDispatch } from "./services/hooks";
import { lazy, Suspense, useEffect, useState } from 'react';

import { Routes, Route, Navigate, useLocation } from 'react-router';
import { setCurrentUser, verifPassord } from './services/userServices/authActions';
import { getCurrentSite } from './services/siteServices/siteActions';
import api from './services/api';
import AuthLayout from "./layouts/AuthContainer";
import PasswordModalContainer from "./layouts/PasswordModalContainer";


const AdminLayout = lazy(() => import('./layouts/AdminContainer'));

const AppRouter = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector(state => state.auth);
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const meResponse = await api.get("/api/users/me");
        const { user } = meResponse.data || {};
        if (user) {
          localStorage.setItem('role', user.role);
          dispatch(setCurrentUser({ user }));
          dispatch(getCurrentSite());
          await dispatch(verifPassord());
        } else {
          dispatch(setCurrentUser({}));
        }
      } catch (e) {
        dispatch(setCurrentUser({}));
      }
      setAuthChecked(true);
    };

    initializeAuth();
  }, [dispatch]);

  if (!authChecked) {
    return <div>Loading...</div>;
  }
  const renderLoader = () => <p>Loading</p>;


  return (
    <>
      <Routes>
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route
        path="/admin/*"
        element={
          auth.isAuthenticated ? (
            <Suspense fallback={renderLoader()}>
              <AdminLayout />
            </Suspense>
          ) : (
            <Navigate to="/auth/login" />
        )
        }
      />
        <Route
          path="/"
          element={
            auth.isAuthenticated ? (
              <Navigate to="/admin/dashboard" replace />
            ) : (
              <Navigate to="/auth/login" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />

    </Routes>
      {auth.isAuthenticated && auth.verifPass && (
        <PasswordModalContainer mandatory />
      )}
    </>
  );
};

export default AppRouter;
